import { render, staticRenderFns } from "./student-score-sheet.vue?vue&type=template&id=20148517"
import script from "./student-score-sheet.vue?vue&type=script&lang=js"
export * from "./student-score-sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports